<template>
  <div>
    <el-dialog title="菜单设置" :visible.sync="dialogMenu.show" width="30%" @opened="opened()" :modal="false">
      <div style="height:300px;" id="menu">
        <el-scrollbar style="height:100%">
          <form id="menuForm">
            <div v-for="item in menu">
              <div class="menu_pare">{{ item.name }}</div>
              <el-row v-for="child in item.childList" :key="child.code">
                <el-col class="menu">
                  &nbsp;&nbsp;&nbsp;{{ child.name }}
                </el-col>
                <el-row v-for="sensor in child.childList" :key="sensor.code">
                  <el-col :span="12">
                    <input type="checkbox" v-model="menuChecked" :value="String(sensor.code)" :id="'sensor'+sensor.code">
                    <label :for="'sensor'+sensor.code">{{ sensor.name }}</label>
                  </el-col>
                  <el-col :span="12" v-if="sensor.sensorAlgorithmOldList && sensor.sensorAlgorithmOldList.length">
                    <select v-model="algorithmSelected[sensor.code]" :disabled="!menuChecked.includes(String(sensor.code))">
                      <option value="-1">请选择传感器算法</option>
                      <option v-for="alg in sensor.sensorAlgorithmOldList" :key="alg.id" :value="String(alg.id)">
                        {{ alg.sensorName }}
                      </option>
                    </select>
                  </el-col>
                </el-row>
              </el-row>
            </div>
          </form>
        </el-scrollbar>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button type="info" @click="showCustomProjectDialog" style="margin-right: 10px;">自定义项目</el-button>
        <el-button type="primary" @click="saveMenus()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 自定义项目管理弹窗 -->
    <el-dialog title="自定义项目管理" :visible.sync="customProjectDialogVisible" width="70%" :modal="false">
      <div style="margin-bottom: 20px;">
        <el-button type="primary" @click="showAddProjectForm">增加项目</el-button>
      </div>
      
      <!-- 项目列表 -->
      <div v-if="customProjects.length === 0" style="text-align: center; padding: 20px; border: 1px dashed #d9d9d9; border-radius: 4px;">
        暂无自定义项目，点击"增加项目"开始创建
      </div>
      <div v-else>
        <div v-for="(project, projectIndex) in customProjects" :key="projectIndex" style="margin-bottom: 20px; border: 1px solid #e4e7ed; padding: 15px; border-radius: 4px;">
          <!-- 项目头部 -->
          <div style="display: flex; align-items: center; margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #f0f0f0;">
            <el-input v-model="project.name" placeholder="一级名称" style="width: 250px; margin-right: 15px;"></el-input>
            <el-button type="primary" size="mini" @click="saveProjectEdit(projectIndex)" style="margin-right: 10px;">保存</el-button>
            <el-button type="danger" size="mini" @click="deleteProject(projectIndex)">删除项目</el-button>
          </div>
          
          <!-- 二级项目编辑 -->
          <div v-for="(level2, level2Index) in project.childList" :key="level2Index" style="margin-left: 20px; margin-bottom: 15px; border-left: 2px solid #409eff; padding-left: 15px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <el-input v-model="level2.name" placeholder="二级名称" style="width: 200px; margin-right: 15px;"></el-input>
              <el-button type="danger" size="mini" @click="removeLevel2FromEdit(projectIndex, level2Index)" :disabled="project.childList.length === 1" style="margin-right: 10px;">删除二级</el-button>
              <el-button type="success" size="mini" @click="addLevel3ToEdit(projectIndex, level2Index)">添加三级项目</el-button>
            </div>
            
            <!-- 三级项目编辑 -->
            <div v-for="(level3, level3Index) in level2.childList" :key="level3Index" style="margin-left: 20px; margin-bottom: 8px;">
              <div style="display: flex; align-items: center;">
                <el-input v-model="level3.name" placeholder="三级名称" style="width: 180px; margin-right: 15px;"></el-input>
                <el-button type="danger" size="mini" @click="removeLevel3FromEdit(projectIndex, level2Index, level3Index)" :disabled="level2.childList.length === 1">删除</el-button>
              </div>
            </div>
          </div>
          <el-button type="primary" size="mini" @click="addLevel2ToEdit(projectIndex)" style="margin-top: 10px;">添加二级项目</el-button>
        </div>
      </div>
      
      <!-- 增加项目表单 -->
      <div v-if="showAddForm" style="margin-top: 20px; padding: 20px; border: 1px solid #409eff; border-radius: 4px; background-color: #f8f9fa;">
        <h4 style="margin-bottom: 15px; color: #409eff;">添加新项目</h4>
        <el-form :model="newProjectForm" label-width="100px">
          <el-form-item label="一级名称:" required>
            <el-input v-model="newProjectForm.level1" placeholder="请输入一级名称" style="width: 300px;"></el-input>
          </el-form-item>
          
          <!-- 二级项目列表 -->
          <el-form-item label="二级项目:">
            <div v-for="(level2, index2) in newProjectForm.level2List" :key="index2" style="margin-bottom: 15px; border: 1px solid #e4e7ed; padding: 10px; border-radius: 4px;">
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <el-input v-model="level2.name" placeholder="请输入二级名称" style="width: 200px; margin-right: 10px;"></el-input>
                <el-button type="danger" size="mini" @click="removeLevel2(index2)" :disabled="newProjectForm.level2List.length === 1">删除二级</el-button>
              </div>
              
              <!-- 三级项目列表 -->
              <div style="margin-left: 20px;">
                <div style="margin-bottom: 10px;">
                  <el-button type="success" size="mini" @click="addLevel3(index2)">添加三级项目</el-button>
                </div>
                <div v-for="(level3, index3) in level2.level3List" :key="index3" style="display: flex; align-items: center; margin-bottom: 8px;">
                  <el-input v-model="level3.name" placeholder="请输入三级名称" style="width: 180px; margin-right: 10px;"></el-input>
                  <el-button type="danger" size="mini" @click="removeLevel3(index2, index3)" :disabled="level2.level3List.length === 1">删除</el-button>
                </div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="addLevel2">添加二级项目</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 15px;">
          <el-button @click="cancelAddProject">取消</el-button>
          <el-button type="primary" @click="addProject()" style="margin-left: 10px;">确定添加</el-button>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="customProjectDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "menuSelect",
  props: {
    dialogMenu: Object,
    menu: {
      type: Array,
      default: () => []
    },
    chosed: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menuChecked: [], // 选中的传感器code（字符串数组）
      algorithmSelected: {}, // { [sensorCode]: algorithmId }
      menusData: [], // 保存数据集合
      token: '',
      options: {},
      customProjectDialogVisible: false, // 自定义项目管理弹窗显示状态
      showAddForm: false, // 是否显示添加项目表单
      customProjects: [], // 自定义项目列表
      newProjectForm: {
        level1: '',
        level2List: [{
          name: '',
          level3List: [{
            name: ''
          }]
        }]
      }
    }
  },
  mounted: function () {

  },
  methods: {
    closeDialog() {
      this.dialogMenu.show = false;
    },
    opened() {
      this.menusData = [];
      this.menuChecked = [];
      this.algorithmSelected = {};
      // 加载自定义项目列表
      this.loadCustomProjects();
      this.$axios.get('/api/monitor/project/child/getChildProjectMenu?id=' + this.dialogMenu.childProjectId).then(res => {
        const values = res.data.datas.values || [];
        this.menusData = values;
        // 回显已选中的code
        this.menuChecked = values.map(menu => String(menu.objectId));
        // 回显算法选择
        values.forEach(menu => {
          if (menu.algorithmId !== undefined && menu.algorithmId !== null) {
            this.algorithmSelected[menu.objectId] = String(menu.algorithmId);
          }
        });
      });
    },
    saveMenus() {
      // 组装要提交的数据
      const data = this.menuChecked.map(code => {
        return {
          objectId: code,
          childProjectId: this.dialogMenu.childProjectId,
          algorithmId: this.algorithmSelected[code] || -1
        }
      });
      this.$axios.post('/api/monitor/project/child/saveChildProjectMenu', data).then(res => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: res.data.datas.values,
            type: 'success'
          });
          this.dialogMenu.show = false;
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      })
    },
    // 显示自定义项目管理弹窗
    showCustomProjectDialog() {
      this.customProjectDialogVisible = true;
      this.loadCustomProjects();
      this.showAddForm = false;
    },
    // 显示添加项目表单
    showAddProjectForm() {
      this.showAddForm = true;
      this.resetNewProjectForm();
    },
    // 取消添加项目
    cancelAddProject() {
      this.showAddForm = false;
      this.resetNewProjectForm();
    },
    // 重置新增项目表单
    resetNewProjectForm() {
      this.newProjectForm = {
        level1: '',
        level2List: [{
          name: '',
          level3List: [{
            name: ''
          }]
        }]
      };
    },
    // 添加二级项目
    addLevel2() {
      this.newProjectForm.level2List.push({
        name: '',
        level3List: [{
          name: ''
        }]
      });
    },
    // 删除二级项目
    removeLevel2(index) {
      if (this.newProjectForm.level2List.length > 1) {
        this.newProjectForm.level2List.splice(index, 1);
      }
    },
    // 添加三级项目
    addLevel3(level2Index) {
      this.newProjectForm.level2List[level2Index].level3List.push({
        name: ''
      });
    },
    // 删除三级项目
    removeLevel3(level2Index, level3Index) {
      const level2 = this.newProjectForm.level2List[level2Index];
      if (level2.level3List.length > 1) {
        level2.level3List.splice(level3Index, 1);
      }
    },
    // 增加项目
    addProject() {
      if (!this.newProjectForm.level1) {
        this.$message({
          showClose: true,
          message: '请填写一级名称',
          type: 'warning'
        });
        return;
      }
      
      // 验证二级和三级项目
      for (let level2 of this.newProjectForm.level2List) {
        if (!level2.name.trim()) {
          this.$message({
            showClose: true,
            message: '请填写所有二级名称',
            type: 'warning'
          });
          return;
        }
        
        for (let level3 of level2.level3List) {
          if (!level3.name.trim()) {
            this.$message({
              showClose: true,
              message: '请填写所有三级名称',
              type: 'warning'
            });
            return;
          }
        }
      }
      
      // 生成唯一的code
      const timestamp = Date.now();
      const newProject = {
        code: `custom_${timestamp}`,
        name: this.newProjectForm.level1,
        childList: this.newProjectForm.level2List.map((level2, level2Index) => ({
          code: `custom_${timestamp}_${level2Index}`,
          name: level2.name,
          childList: level2.level3List.map((level3, level3Index) => ({
            code: `custom_${timestamp}_${level2Index}_${level3Index}`,
            name: level3.name
          }))
        }))
      };
      
      // 保存到本地存储
      this.saveCustomProjectToLocal(newProject);
      
      this.$message({
        showClose: true,
        message: '项目添加成功',
        type: 'success'
      });
      
      this.showAddForm = false;
      this.resetNewProjectForm();
    },
    // 保存自定义项目到本地存储
    saveCustomProjectToLocal(project) {
      const customProjects = JSON.parse(localStorage.getItem('customProjects') || '[]');
      customProjects.push(project);
      localStorage.setItem('customProjects', JSON.stringify(customProjects));
      // 更新当前列表
      this.customProjects = customProjects;
    },
    // 加载自定义项目列表
    loadCustomProjects() {
      try {
        this.customProjects = JSON.parse(localStorage.getItem('customProjects') || '[]');
      } catch (error) {
        console.error('加载自定义项目失败:', error);
        this.customProjects = [];
      }
    },
    // 保存项目编辑
    saveProjectEdit(projectIndex) {
      const customProjects = JSON.parse(localStorage.getItem('customProjects') || '[]');
      customProjects[projectIndex] = this.customProjects[projectIndex];
      localStorage.setItem('customProjects', JSON.stringify(customProjects));
      this.$message({
        type: 'success',
        message: '保存成功!'
      });
    },
    // 在编辑中添加二级项目
    addLevel2ToEdit(projectIndex) {
      const timestamp = Date.now();
      this.customProjects[projectIndex].childList.push({
        code: `custom_${timestamp}_new`,
        name: '',
        childList: [{
          code: `custom_${timestamp}_new_0`,
          name: ''
        }]
      });
    },
    // 在编辑中删除二级项目
    removeLevel2FromEdit(projectIndex, level2Index) {
      if (this.customProjects[projectIndex].childList.length > 1) {
        this.customProjects[projectIndex].childList.splice(level2Index, 1);
      }
    },
    // 在编辑中添加三级项目
    addLevel3ToEdit(projectIndex, level2Index) {
      const timestamp = Date.now();
      this.customProjects[projectIndex].childList[level2Index].childList.push({
        code: `custom_${timestamp}_new`,
        name: ''
      });
    },
    // 在编辑中删除三级项目
    removeLevel3FromEdit(projectIndex, level2Index, level3Index) {
      const level2 = this.customProjects[projectIndex].childList[level2Index];
      if (level2.childList.length > 1) {
        level2.childList.splice(level3Index, 1);
      }
    },
    // 删除项目
    deleteProject(projectIndex) {
      this.$confirm('确定要删除这个项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const customProjects = JSON.parse(localStorage.getItem('customProjects') || '[]');
        customProjects.splice(projectIndex, 1);
        localStorage.setItem('customProjects', JSON.stringify(customProjects));
        this.customProjects = customProjects;
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
  watch: {
    // 取消勾选时清除算法选择
    menuChecked(newVal, oldVal) {
      // 找出被取消的code
      const removed = oldVal.filter(code => !newVal.includes(code));
      removed.forEach(code => {
        this.$set(this.algorithmSelected, code, undefined);
      });
    }
  }
}
</script>

<style>

#menu .el-scrollbar__wrap {
  overflow-x: hidden;
}

.menu_pare {
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
}

.menu {
  line-height: 20px;
  font-weight: bold;
}
</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/project/menu-select-dialog.vue